import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { useLogin } from "@/api/hooks";
import { Button, Field, Input, Notice } from "@/components/ui";
import { AuthLayout } from "@/layouts/AuthLayout";
import { errorMessage } from "@/lib/errors";

export function LoginPage() {
  const { t } = useTranslation();
  const login = useLogin();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  // On success the session cache moves to a pending stage and the route guard redirects.
  const submit = (e: FormEvent) => {
    e.preventDefault();
    login.mutate({ username: username.trim(), password });
  };

  return (
    <AuthLayout step={1}>
      <div>
        <h1 className="m-0 mb-1.5 text-[21px] font-semibold">{t("auth.signInTitle")}</h1>
        <p className="m-0 text-muted">{t("auth.signInHint")}</p>
      </div>
      <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
        {login.isError && <Notice tone="blocked">{errorMessage(t, login.error)}</Notice>}
        <Field label={t("auth.username")}>
          {(p) => (
            <Input
              {...p}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              autoFocus
              required
            />
          )}
        </Field>
        <Field label={t("auth.password")}>
          {(p) => (
            <Input
              {...p}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          )}
        </Field>
        <Button
          type="submit"
          variant="primary"
          size="lg"
          icon="lock"
          loading={login.isPending}
          disabled={!username.trim() || !password}
        >
          {t("auth.signIn")}
        </Button>
      </form>
    </AuthLayout>
  );
}
